import { memo } from "react";
import { formatCurrency, useTranslate } from "helpers";
import { VehicleInfoCardProps } from "./types";

// Zaglavlje oglasa — naziv vozila i cijena, isti raspored i stil kao ListingHeader.
const VehicleInfoCard: React.FC<VehicleInfoCardProps> = (props) => {
  const { formValues, vehicleTitle, vehicleYear } = props;
  const { t } = useTranslate();

  return (
    <div className="border-b border-slate-200 pt-4 px-4">
      <div className="flex justify-between items-start mb-4 gap-4">
        <div className="max-w-xl">
          <div className="text-md font-bold text-slate-600 truncate">
            {vehicleTitle} {vehicleYear ? `(${vehicleYear})` : ""}
          </div>
          <div className="text-sm text-slate-600">{formValues.vehicleType?.name ?? ""}</div>
        </div>
        <div>
          <div className="text-sm text-green-600 text-right">
            {t("admin.sales.listing.detail.price")}
          </div>
          <div className="text-xl font-semibold text-green-600 truncate text-right">
            {formValues.price?.sellingPrice != null
              ? formatCurrency.format(formValues.price.sellingPrice)
              : "-"}
          </div>
        </div>
      </div>
    </div>
  );
};

export default memo(VehicleInfoCard);
